import * as Yup from "yup";
import contaPagarValidator from "../../addContaPagar/middlewares/contaPagar.validator";

const contaPagarDesdobrarTituloValidator = contaPagarValidator.shape({
  rateiosCentroCustoList: Yup.array().nullable().optional(),
  rateiosPlanoFinanceiroList: Yup.array().nullable().optional(),
});

export default contaPagarDesdobrarTituloValidator;